import { useState, useRef } from "react";
import { Mail, MailOpen, Trash2 } from "lucide-react";
import { SWIPE_THRESHOLD } from "./inboxUtils";

export const SwipeRow = ({ it, isInbox, onDelete, onToggleRead, children, className = "", style }) => {
  const [dx, setDx] = useState(0);
  const [swiping, setSwiping] = useState(false);
  const start = useRef({ x: 0, y: 0, active: false });
  const moved = useRef(false);

  const onTouchStart = (e) => {
    const t = e.touches[0];
    start.current = { x: t.clientX, y: t.clientY, active: true };
    moved.current = false;
  };
  const onTouchMove = (e) => {
    if (!start.current.active) return;
    const t = e.touches[0];
    const diffX = t.clientX - start.current.x;
    const diffY = t.clientY - start.current.y;
    if (Math.abs(diffX) < Math.abs(diffY)) return;
    if (Math.abs(diffX) > 8) moved.current = true;
    setSwiping(true);
    let clamped = Math.max(-140, Math.min(140, diffX));
    if (clamped > 0 && !isInbox) clamped = 0;
    setDx(clamped);
  };
  const onTouchEnd = () => {
    if (!start.current.active) return;
    start.current.active = false;
    const d = dx;
    setSwiping(false);
    setDx(0);
    if (d <= -SWIPE_THRESHOLD) onDelete(it);
    else if (d >= SWIPE_THRESHOLD && isInbox) onToggleRead(it);
  };
  const onClickCapture = (e) => {
    if (moved.current) { e.stopPropagation(); e.preventDefault(); moved.current = false; }
  };

  return (
    <div className={`relative overflow-hidden ${className}`} style={style} data-testid={`swipe-row-${it.id}`}>
      <div className="absolute inset-y-0 left-0 flex items-center gap-2 px-5 bg-[#007BFF] text-white text-xs font-semibold pointer-events-none"
        style={{ opacity: dx > 10 ? 1 : 0 }}>
        {it.is_read ? <Mail className="h-5 w-5" /> : <MailOpen className="h-5 w-5" />}
        {it.is_read ? "Da leggere" : "Letta"}
      </div>
      <div className="absolute inset-y-0 right-0 flex items-center gap-2 px-5 bg-red-500 text-white text-xs font-semibold pointer-events-none"
        style={{ opacity: dx < -10 ? 1 : 0 }}>
        <Trash2 className="h-5 w-5" />Elimina
      </div>
      <div
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        onClickCapture={onClickCapture}
        style={{ transform: `translateX(${dx}px)`, transition: swiping ? "none" : "transform 0.2s ease" }}
        className="relative bg-transparent rounded-xl"
      >
        {children}
      </div>
    </div>
  );
};
